import React, { useEffect, useState } from "react";
import { getZonedTime, tsToDate } from "../../helpers/date.helper";
import SportMarketStandard from "../SportMarketStandard/SportMarketStandard";
import { connectUpcomingRacesAccordion } from "./UpcomingRacesAccordion.connect";
import "./UpcomingRacesAccordion.scss";
import { joidTigari } from "../../helpers/joditigari.helper";
import { useLocation, useNavigate } from "react-router-dom";
import HorseLoader from "./HorseLoader";
import GreyhoundLoader from "./GreyHoundLoader";

const UpcomingRacesAccordion = ({
  item,
  index,
  timeSettings,
  betPlacing,
  raceOdds,
  showHeader = false,
  showJockeyName = false,
  isAccordionOpen,
  setIsAccordionOpen,
  actions,
}) => {
  const location = useLocation();
  const [allRunnerSuspend, setAllRunnerSuspend] = useState(false);
  const [eventID, setEventId] = useState(null);
  const [selectedRaces, setSelectedRaces] = useState([]);
  const [combinedMarket, setCombinedMarket] = useState(null);

  useEffect(() => {
    if (selectedRaces.length <= 1) {
      setCombinedMarket(null);
    } else {
      let horseData = joidTigari(selectedRaces);
      setCombinedMarket(horseData);
    }
  }, [selectedRaces]);

  useEffect(() => {
    if (
      raceOdds &&
      raceOdds[`${eventID} ${isAccordionOpen}`]?.runners?.filter(
        (runner) => runner.status !== "SUSPENDED",
      ).length >= 1
    ) {
      setAllRunnerSuspend(false);
    } else {
      setAllRunnerSuspend(true);
    }
  }, [raceOdds, eventID, isAccordionOpen]);

  const slicedItem = { ...item, runners: item?.runners?.slice(0, 3) };

  let flag = slicedItem?.country_code?.toLowerCase();

  const setEvent = (item) => {
    setIsAccordionOpen(item?.market_id);
    setEventId(item?.match_id);

    actions.requestRaceOdds(item?.match_id, item?.market_id);
  };

  const getTimeDifference = (dateTime) => {
    const targetDate = new Date(dateTime);
    const currentDate = new Date();

    const diffInMs = targetDate.getTime() - currentDate.getTime();
    const isPast = diffInMs < 0;
    const diffInSeconds = Math.abs(diffInMs) / 1000;

    const days = Math.floor(diffInSeconds / (3600 * 24));
    const hours = Math.floor((diffInSeconds % (3600 * 24)) / 3600);
    const minutes = Math.floor((diffInSeconds % 3600) / 60);

    if (isPast) {
      if (days > 0) return `Started on ${days} days ${hours} hours`;
      return `Started on ${hours} hours ${minutes} minutes`;
    } else {
      if (days > 0) return `Opens in ${days} days ${hours} hours`;
      return `Opens in ${hours} hours ${minutes} minutes`;
    }
  };

  const nav = useNavigate();

  return (
    <div
      key={slicedItem?.market_id + index}
      className="race-page__content-upcoming-races-table-row"
    >
      <div
        className="flex items-center justify-between w-full px-2.5 py-2"
        style={{ backgroundColor: "#fff" }}
      >
        <div
          className="flex items-center gap-x-2 text-text_color_primary1 f32"
          onClick={() => {
            nav(
              `/event-page/${slicedItem?.sport_id}/${slicedItem?.match_id}/${slicedItem?.market_id}`,
            );
          }}
        >
          <div className={`flag ${flag}`}></div>
          {/* <svg height="20" width="20" viewBox="0 -4 28 28" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <g clipPath="url(#clip0_503_3486)"> <rect width="28" height="20" rx="2" fill="white"></rect> <mask id="mask0_503_3486" maskUnits="userSpaceOnUse" x="0" y="0" width="28" height="20"> <rect width="28" height="20" rx="2" fill="white"></rect> </mask> <g mask="url(#mask0_503_3486)"> <path fill-rule="evenodd" clip-rule="evenodd" d="M28 0H0V1.33333H28V0ZM28 2.66667H0V4H28V2.66667ZM0 5.33333H28V6.66667H0V5.33333ZM28 8H0V9.33333H28V8ZM0 10.6667H28V12H0V10.6667ZM28 13.3333H0V14.6667H28V13.3333ZM0 16H28V17.3333H0V16ZM28 18.6667H0V20H28V18.6667Z" fill="#D02F44"></path> <rect width="12" height="9.33333" fill="#46467F"></rect> <g filter="url(#filter0_d_503_3486)"> <path fill-rule="evenodd" clip-rule="evenodd" d="M2.66665 1.99999C2.66665 2.36818 2.36817 2.66666 1.99998 2.66666C1.63179 2.66666 1.33331 2.36818 1.33331 1.99999C1.33331 1.63181 1.63179 1.33333 1.99998 1.33333C2.36817 1.33333 2.66665 1.63181 2.66665 1.99999ZM5.33331 1.99999C5.33331 2.36818 5.03484 2.66666 4.66665 2.66666C4.29846 2.66666 3.99998 2.36818 3.99998 1.99999C3.99998 1.63181 4.29846 1.33333 4.66665 1.33333C5.03484 1.33333 5.33331 1.63181 5.33331 1.99999ZM7.33331 2.66666C7.7015 2.66666 7.99998 2.36818 7.99998 1.99999C7.99998 1.63181 7.7015 1.33333 7.33331 1.33333C6.96512 1.33333 6.66665 1.63181 6.66665 1.99999C6.66665 2.36818 6.96512 2.66666 7.33331 2.66666ZM10.6666 1.99999C10.6666 2.36818 10.3682 2.66666 9.99998 2.66666C9.63179 2.66666 9.33331 2.36818 9.33331 1.99999C9.33331 1.63181 9.63179 1.33333 9.99998 1.33333C10.3682 1.33333 10.6666 1.63181 10.6666 1.99999ZM3.33331 3.99999C3.7015 3.99999 3.99998 3.70152 3.99998 3.33333C3.99998 2.96514 3.7015 2.66666 3.33331 2.66666C2.96512 2.66666 2.66665 2.96514 2.66665 3.33333C2.66665 3.70152 2.96512 3.99999 3.33331 3.99999ZM6.66665 3.33333C6.66665 3.70152 6.36817 3.99999 5.99998 3.99999C5.63179 3.99999 5.33331 3.70152 5.33331 3.33333C5.33331 2.96514 5.63179 2.66666 5.99998 2.66666C6.36817 2.66666 6.66665 2.96514 6.66665 3.33333ZM8.66665 3.99999C9.03484 3.99999 9.33331 3.70152 9.33331 3.33333C9.33331 2.96514 9.03484 2.66666 8.66665 2.66666C8.29846 2.66666 7.99998 2.96514 7.99998 3.33333C7.99998 3.70152 8.29846 3.99999 8.66665 3.99999ZM10.6666 4.66666C10.6666 5.03485 10.3682 5.33333 9.99998 5.33333C9.63179 5.33333 9.33331 5.03485 9.33331 4.66666C9.33331 4.29847 9.63179 3.99999 9.99998 3.99999C10.3682 3.99999 10.6666 4.29847 10.6666 4.66666ZM7.33331 5.33333C7.7015 5.33333 7.99998 5.03485 7.99998 4.66666C7.99998 4.29847 7.7015 3.99999 7.33331 3.99999C6.96512 3.99999 6.66665 4.29847 6.66665 4.66666C6.66665 5.03485 6.96512 5.33333 7.33331 5.33333ZM5.33331 4.66666C5.33331 5.03485 5.03484 5.33333 4.66665 5.33333C4.29846 5.33333 3.99998 5.03485 3.99998 4.66666C3.99998 4.29847 4.29846 3.99999 4.66665 3.99999C5.03484 3.99999 5.33331 4.29847 5.33331 4.66666ZM1.99998 5.33333C2.36817 5.33333 2.66665 5.03485 2.66665 4.66666C2.66665 4.29847 2.36817 3.99999 1.99998 3.99999C1.63179 3.99999 1.33331 4.29847 1.33331 4.66666C1.33331 5.03485 1.63179 5.33333 1.99998 5.33333ZM3.99998 5.99999C3.99998 6.36819 3.7015 6.66666 3.33331 6.66666C2.96512 6.66666 2.66665 6.36819 2.66665 5.99999C2.66665 5.6318 2.96512 5.33333 3.33331 5.33333C3.7015 5.33333 3.99998 5.6318 3.99998 5.99999ZM5.99998 6.66666C6.36817 6.66666 6.66665 6.36819 6.66665 5.99999C6.66665 5.6318 6.36817 5.33333 5.99998 5.33333C5.63179 5.33333 5.33331 5.6318 5.33331 5.99999C5.33331 6.36819 5.63179 6.66666 5.99998 6.66666ZM9.33331 5.99999C9.33331 6.36819 9.03484 6.66666 8.66665 6.66666C8.29846 6.66666 7.99998 6.36819 7.99998 5.99999C7.99998 5.6318 8.29846 5.33333 8.66665 5.33333C9.03484 5.33333 9.33331 5.6318 9.33331 5.99999ZM9.99998 8C10.3682 8 10.6666 7.70152 10.6666 7.33333C10.6666 6.96514 10.3682 6.66666 9.99998 6.66666C9.63179 6.66666 9.33331 6.96514 9.33331 7.33333C9.33331 7.70152 9.63179 8 9.99998 8ZM7.99998 7.33333C7.99998 7.70152 7.7015 8 7.33331 8C6.96512 8 6.66665 7.70152 6.66665 7.33333C6.66665 6.96514 6.96512 6.66666 7.33331 6.66666C7.7015 6.66666 7.99998 6.96514 7.99998 7.33333ZM4.66665 8C5.03484 8 5.33331 7.70152 5.33331 7.33333C5.33331 6.96514 5.03484 6.66666 4.66665 6.66666C4.29846 6.66666 3.99998 6.96514 3.99998 7.33333C3.99998 7.70152 4.29846 8 4.66665 8ZM2.66665 7.33333C2.66665 7.70152 2.36817 8 1.99998 8C1.63179 8 1.33331 7.70152 1.33331 7.33333C1.33331 6.96514 1.63179 6.66666 1.99998 6.66666C2.36817 6.66666 2.66665 6.96514 2.66665 7.33333Z" fill="url(#paint0_linear_503_3486)"></path> </g> </g> </g> <defs> <filter id="filter0_d_503_3486" x="1.33331" y="1.33333" width="9.33331" height="7.66667" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"> <feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood> <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix> <feOffset dy="1"></feOffset> <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"></feColorMatrix> <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_503_3486"></feBlend> <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_503_3486" result="shape"></feBlend> </filter> <linearGradient id="paint0_linear_503_3486" x1="1.33331" y1="1.33333" x2="1.33331" y2="7.99999" gradientUnits="userSpaceOnUse"> <stop stopColor="white"></stop> <stop offset="1" stopColor="#F0F0F0"></stop> </linearGradient> <clipPath id="clip0_503_3486"> <rect width="28" height="20" rx="2" fill="white"></rect> </clipPath> </defs> </g></svg> */}

          <div className="flex items-start flex-col">
            <span className=" text-base font-[700]">
              {slicedItem?.venue}
              &nbsp; ({slicedItem?.country_code})
            </span>
            <span className=" text-xs font-[400] ">
              {getTimeDifference(
                getZonedTime(
                  timeSettings?.timeZoneName,
                  slicedItem?.market_start_time,
                ),
              )}
            </span>
          </div>
        </div>
        <div className="flex items-center justify-center gap-x-3">
          <span>
            {slicedItem?.inplay ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 29 29"
                fill="none"
              >
                <g clipPath="url(#clip0_1696_2272)">
                  <path
                    d="M14.5 2.83337C8.06004 2.83337 2.83337 8.06004 2.83337 14.5C2.83337 20.94 8.06004 26.1667 14.5 26.1667C20.94 26.1667 26.1667 20.94 26.1667 14.5C26.1667 8.06004 20.94 2.83337 14.5 2.83337ZM12.1667 19.75V9.25004L19.1667 14.5L12.1667 19.75Z"
                    fill="#bd3726"
                  ></path>
                </g>
                <defs>
                  <clipPath id="clip0_1696_2272">
                    <rect
                      width="28"
                      height="28"
                      fill="white"
                      transform="translate(0.5 0.5)"
                    ></rect>
                  </clipPath>
                </defs>
              </svg>
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
              >
                <g clipPath="url(#clip0_2152_26700)">
                  <path
                    d="M10.8506 9.41291L8.61975 7.73979V4.3316C8.61975 3.98891 8.34275 3.71191 8.00006 3.71191C7.65737 3.71191 7.38037 3.98891 7.38037 4.3316V8.04966C7.38037 8.24485 7.47209 8.42891 7.62825 8.54541L10.1069 10.4044C10.2185 10.4881 10.3486 10.5284 10.4781 10.5284C10.6671 10.5284 10.853 10.4435 10.9745 10.2799C11.1803 10.0066 11.1245 9.61804 10.8506 9.41291Z"
                    fill="url(#paint0_linear_2152_26700)"
                  ></path>
                  <path
                    d="M8 0C3.58853 0 0 3.58853 0 8C0 12.4115 3.58853 16 8 16C12.4115 16 16 12.4115 16 8C16 3.58853 12.4115 0 8 0ZM8 14.7607C4.27266 14.7607 1.23934 11.7273 1.23934 8C1.23934 4.27266 4.27266 1.23934 8 1.23934C11.728 1.23934 14.7607 4.27266 14.7607 8C14.7607 11.7273 11.7273 14.7607 8 14.7607Z"
                    fill="url(#paint1_linear_2152_26700)"
                  ></path>
                </g>
                <defs>
                  <linearGradient
                    id="paint0_linear_2152_26700"
                    x1="7.38037"
                    y1="10.9544"
                    x2="11.5202"
                    y2="10.6827"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stopColor="#C10B32"></stop>
                    <stop offset="1" stopColor="#6A061C"></stop>
                  </linearGradient>
                  <linearGradient
                    id="paint1_linear_2152_26700"
                    x1="-1.1269e-07"
                    y1="17"
                    x2="17.6354"
                    y2="14.8782"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stopColor="#C10B32"></stop>
                    <stop offset="1" stopColor="#6A061C"></stop>
                  </linearGradient>
                  <clipPath id="clip0_2152_26700">
                    <rect width="16" height="16" fill="white"></rect>
                  </clipPath>
                </defs>
              </svg>
            )}
          </span>
          <button
            onClick={() =>
              isAccordionOpen === slicedItem?.market_id
                ? setIsAccordionOpen(null)
                : setEvent(slicedItem)
            }
            className={`transition-all ease-in-out duration-300 transform ${
              isAccordionOpen === slicedItem?.market_id ? "rotate-180" : ""
            }`}
          >
            <svg
              fill="#bd3726"
              width="16"
              height="16"
              version="1.1"
              id="Layer_1"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 330 330"
            >
              <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
              <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
              ></g>
              <g id="SVGRepo_iconCarrier">
                <path
                  id="XMLID_225_"
                  d="M325.607,79.393c-5.857-5.857-15.355-5.858-21.213,0.001l-139.39,139.393L25.607,79.393 c-5.857-5.857-15.355-5.858-21.213,0.001c-5.858,5.858-5.858,15.355,0,21.213l150.004,150c2.813,2.813,6.628,4.393,10.606,4.393 s7.794-1.581,10.606-4.394l149.996-150C331.465,94.749,331.465,85.251,325.607,79.393z"
                ></path>
              </g>
            </svg>
          </button>
        </div>
      </div>

      {/* <div
        className="race-page__content-upcoming-races-table-row-header f32"
        onClick={() =>
          isAccordionOpen === slicedItem?.market_id
            ? setIsAccordionOpen(null)
            : setEvent(slicedItem)
        }
      >
        <div className={`flag ${flag}`}></div>
        <div className="race-page__content-upcoming-races-table-row-header-text">
          <span
            onClick={() =>
              navigate(
                `/event-page/${slicedItem.sport_id}/${slicedItem.market_id}/${slicedItem.match_id}`
              )
            }
          >
            {slicedItem?.venue}
            &nbsp; ({slicedItem?.country_code})
          </span>
          <span>
            {getTimeDifference(
              getZonedTime(
                timeSettings?.timeZoneName,
                slicedItem?.market_start_time
              )
            )}
          </span>
        </div>

        <div className="flex items-center justify-center gap-x-3">
          <span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 29 29"
              fill="none"
            >
              <g clipPath="url(#clip0_1696_2272)">
                <path
                  d="M14.5 2.83337C8.06004 2.83337 2.83337 8.06004 2.83337 14.5C2.83337 20.94 8.06004 26.1667 14.5 26.1667C20.94 26.1667 26.1667 20.94 26.1667 14.5C26.1667 8.06004 20.94 2.83337 14.5 2.83337ZM12.1667 19.75V9.25004L19.1667 14.5L12.1667 19.75Z"
                  fill="#bd3726"
                ></path>
              </g>
              <defs>
                <clipPath id="clip0_1696_2272">
                  <rect
                    width="28"
                    height="28"
                    fill="white"
                    transform="translate(0.5 0.5)"
                  ></rect>
                </clipPath>
              </defs>
            </svg>
          </span>
        </div>
        <div className="race-page__content-upcoming-races-table-row-header-arrowContainer">
          <span
            className={`race-page__content-upcoming-races-table-row-header-arrow ${
              isAccordionOpen === slicedItem?.market_id ? "active" : ""
            }`}
          ></span>
        </div>
      </div> */}
      {combinedMarket && (
        <div
          className={`race-page__content-upcoming-races-table-row-inner ${
            isAccordionOpen === slicedItem?.market_id ? "open" : ""
          }`}
        >
          <div className="race-page__content-rase-odds-table-header">
            <p>Combined Market</p>
            <div>
              <span>Back</span>
              <span>Lay</span>
            </div>
          </div>
          <div
            className={`race-page__content-upcoming-races-table-row-items-wrapper ${
              allRunnerSuspend === true ? "all-suspended" : ""
            }`}
          >
            {allRunnerSuspend === true && (
              <div className="race-page__content-all-suspend-cover">
                <span>SUSPENDED</span>
              </div>
            )}
            {combinedMarket && (
              <SportMarketStandard
                data={combinedMarket}
                key={combinedMarket?.market_id}
                betPlacing={betPlacing}
                showHeader={false}
                showJockeyName={true}
                isRacing={true}
              />
            )}
          </div>
        </div>
      )}

      <div
        className={`race-page__content-upcoming-races-table-row-inner ${
          isAccordionOpen === slicedItem?.market_id ? "open" : ""
        }`}
      >
        {(!raceOdds || !raceOdds[`${eventID} ${isAccordionOpen}`]) && (
          <>
            {location.pathname.includes("horse-racing") ? (
              <HorseLoader name={slicedItem?.venue} />
            ) : (
              <GreyhoundLoader name={slicedItem?.venue} />
            )}{" "}
          </>
        )}

        <div
          className={`race-page__content-upcoming-races-table-row-items-wrapper ${
            allRunnerSuspend === true ? "all-suspended" : ""
          }`}
          style={{ marginTop: -6 }}
        >
          {/* {allRunnerSuspend === true && (
            <div className="race-page__content-all-suspend-cover">
              <span>SUSPENDED</span>
            </div>
          )} */}

          <SportMarketStandard
            data={raceOdds ? raceOdds[`${eventID} ${isAccordionOpen}`] : {}}
            key={slicedItem?.market_id}
            betPlacing={betPlacing}
            showHeader={showHeader}
            showJockeyName={showJockeyName}
            isRacing={true}
            selectedRaces={selectedRaces}
            setSelectedRaces={setSelectedRaces}
          />
        </div>
      </div>
    </div>
  );
};

export default connectUpcomingRacesAccordion()(UpcomingRacesAccordion);
